import { DialogModal, useModal } from '@shape-ds/components';

import { useCallback, useEffect, useState } from 'react';
import { Control, FieldValues, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useBlocker } from 'react-router-dom';

export const usePreventEditLeave = <TData extends FieldValues>(
  control?: Control<TData, unknown>,
) => {
  const { isSubmitted } = useFormState({ control });
  const url = new URL(window.location.href);
  const { proceed, reset, state } = useBlocker(
    ({ nextLocation }) => url.searchParams.has('edit') && !nextLocation.pathname.includes('edit'),
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { openLeaveModal } = usePreventLeaveModal();
  const isDirty = false; // voltar aqui depois - urgente
  const formStateShouldBlock = isDirty && !isSubmitted;

  if (url.searchParams.has('edit') && !formStateShouldBlock) {
    url.searchParams.delete('edit');
    window.history.replaceState(null, '', url.toString());
  }
  if (!url.searchParams.has('edit') && formStateShouldBlock) {
    url.searchParams.set('edit', 'true');
    window.history.replaceState(null, '', url.toString());
  }
  useEffect(() => {
    if (state === 'blocked' && !isModalOpen) {
      setIsModalOpen(true);
      openLeaveModal(proceed, () => {
        setIsModalOpen(false);
        reset();
      });
    }
  }, [state, isModalOpen, proceed, reset]);

  return null;
};

export const usePreventLeaveModal = () => {
  const { openModal } = useModal();
  const { t } = useTranslation();

  const openLeaveModal = useCallback(
    (onConfirm: () => void, onClose?: () => void) => {
      openModal(
        <DialogModal
          cancelButtonLabel={t('messages:prevent_edit_leave.cancelLabel')}
          message={t('messages:prevent_edit_leave.message')}
          title={t('messages:prevent_edit_leave.title')}
          confirmButtonLabel={t('messages:prevent_edit_leave.confirmLabel')}
          onConfirm={() => {
            const url = new URL(window.location.href);
            url.searchParams.delete('edit');
            window.history.replaceState(null, '', url.toString());
            onConfirm();
          }}
        />,
        {
          onClose,
          width: '540px',
        },
      );
    },
    [openModal, t],
  );

  return { openLeaveModal };
};
